/* global dataLayer */

<template lang="pug">
  component(:is="pdpComponent")
</template>

<script>
  import { mapState, mapActions, mapMutations } from "vuex";

  export default {
    name: "PdpEntry",

    props: {
      urlKey: String,
      cmsSettings: {
        type: Object,
        default: () => ({})
      }
    },

    data() {
      return {
        pdpComponent: "ColorKitPdp",
        productCategory: null
      }
    },

    computed: {
      ...mapState('pdp', ['product']),
      ...mapState('customer', ['cdata'])
    },

    methods: {
      ...mapActions('pdp', ['getProductByUrlKey']),
      ...mapMutations('pdp', ['setCmsSettings']),
      ...mapActions('waitlist', ['initWaitlists']),

      initProduct() {
        this.getProductByUrlKey(this.urlKey).then(() => {
          document.title = this.product.meta_title;
        }).catch(() => {
          window.location.reload();
        });
      }
    },

    watch: {
      urlKey() {
        this.initProduct();
      },

      product(val) {
        if (val && this.cdata) {
          if (val.product_type && val.product_type != this.productCategory) {
            this.productCategory = val.product_type;

            this.trackEvent('Viewed Product Category', {
              category: val.product_type,
            });
          }

          this.trackEvent('Viewed Product', {
            id: val.id,
            sku: val.code,
            name: val.name,
            price: val.price,
            subPrice: val.sub_price,
            category: val.productType,
          });

          var gtmEvent = {
            'prodId': val.id
          };

          var eventNameMap = {
            'root_touch_up': 'RTUPageView',
            'haircare': 'RTUPageView',
            'gloss': 'RTUPageView',
            'styling': 'RTUPageView',
            'color_kit': 'RTUPageView',
            'accessory': 'RTUPageView',
          };

          gtmEvent['event'] = eventNameMap[val.product_type] || 'PageView';
          
          if (val.productColor) {
            gtmEvent['prodColor'] = val.productColor;
          }

          dataLayer.push(gtmEvent);
        }
      }
    },

    created() {
      this.initProduct();
      this.initWaitlists();
      this.setCmsSettings(this.cmsSettings);
    }
  }
</script>

<style scoped lang="stylus">

</style>